import z from "zod";

export const LoadTypeFormSchema = z
    .object({
        loadType: z.enum(['full', 'incremental']),
        scdType: z.string().nonempty('SCD Type is required'),
        deleteIdentifier: z.string().optional(),
        createdDate: z.string().optional(),
        modifiedDate: z.string().optional(),
    })
    .refine(
        (data) => {
            if (data.loadType === 'incremental') {
                const { deleteIdentifier, createdDate, modifiedDate } = data;
                if (!deleteIdentifier || !createdDate || !modifiedDate) {
                    // Defer uniqueness validation until all three are selected.
                    return true;
                }
                // All must be different
                return (
                    deleteIdentifier !== createdDate &&
                    deleteIdentifier !== modifiedDate &&
                    createdDate !== modifiedDate
                );
            }
            return true;
        },
        {
            message:
                'Delete Identifier, Created Date, and Modified Date must be different',
            path: ['deleteIdentifier'],
        }
    );

export type LoadTypeFormData = z.infer<typeof LoadTypeFormSchema>;